  import React, { useState, useEffect } from "react";
  import { useNavigate } from "react-router-dom";
  import { Box, Tabs, Tab } from "@mui/material";
  import useUserInventory from "../../hooks/useUserInventory";
  import data from "../../assets/db/main-db.json";
  import { useDistributor } from "../../hooks/useDistributor";
  import { db } from "../../firebase/firebase";
  import { getDoc,doc } from "firebase/firestore";

  const DistributorInventory = () => {
    const { inventory, loading, error } = useUserInventory();
    const [value, setValue] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterDate, setFilterDate] = useState("");
    const [filteredInventory, setFilteredInventory] = useState([]);


    const getColor=(condition)=>{

      switch(condition.toLowerCase()){
        case "gold":
          return "yellow-500";
        case "platinum":  
          return "gray-300";
        case "silver":
          return "gray-400";
        default:
          return "white"
      }
    
    
    }

    useEffect(() => {
      let filteredData = inventory;

      if (searchQuery) {
        filteredData = filteredData.filter(
          (item) =>
            item.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.variant.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.imei_1.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.imei_2.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.serialNumber &&
              item.serialNumber.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      }

      if (filterDate) {
        filteredData = filteredData.filter((item) => {
          if (!item.createdAt || !item.createdAt.seconds) return false;
          const itemDate = new Date(item.createdAt.seconds * 1000);
          const selectedDate = new Date(filterDate);
          return itemDate.toDateString() === selectedDate.toDateString();
        });
      }

      setFilteredInventory(filteredData);
    }, [searchQuery, filterDate, inventory]);

    if (loading) return <div>Loading Inventory...</div>;
    if (error) return <div>Error: {error}</div>;

    const groupedInventory = filteredInventory.reduce((acc, item) => {
      (acc[item.brand] = acc[item.brand] || []).push(item);
      return acc;
    }, {});

    return (
      <div className="inventory-container">

        {/* Tabs for Available & Sold Inventory */}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={(e, newValue) => setValue(newValue)}
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: "red" },
              "& .MuiTab-root": { color: "red" },
              "& .Mui-selected": { color: "red", fontWeight: "bold" },
            }}
          >
            <Tab label="Available Inventory" />
            <Tab label="Sold Inventory" />
          </Tabs>
        </Box>

        {/* Available Inventory */}
        {value === 0 && (
          <>
          {/* Search and Filter Inputs */}
          <div className="flex mt-5">
          <input
            type="text"
            placeholder="Search Available Inventory..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-80 h-10 px-4 text-black rounded border border-gray-300"
          />
        </div>
            {Object.keys(groupedInventory).length === 0 ? (
              <div className="text-center py-10">
                <h2 className="text-2xl font-bold text-gray-500">No items available</h2>
              </div>
            ) : (
              Object.keys(groupedInventory).map((brand) => (
                <div key={brand} className="my-4">
                  <h2 className="bg-red-600 text-center text-xl rounded-lg">{brand}</h2>
                  <div className="flex gap-4 overflow-x-auto p-5">
                    {groupedInventory[brand].map((item) => {
                      const brandData = data.brands.find((b) =>
                        b.models.some((model) => model.name === item.model)
                      );
                      const modelData = brandData?.models.find((m) => m.name === item.model);
                      const imageUrl = modelData?.imageUrl || "https://via.placeholder.com/100";

                      return (
                        <div
                          key={item.id}
                          className="bg-white border border-gray-200 rounded-lg w-[300px] shrink-0 p-5 shadow-xl flex flex-col items-center"
                        >
                          <div className="flex w-full justify-between mb-1">
                            <h3 className="text-sm font-bold text-gray-800">{item.model}</h3>
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full bg-${getColor(item.condition)} text-white`}>
                              {item.condition}
                            </span>
                          </div>
                          <div className="flex-1 text-gray-700 text-xs space-y-1 w-full flex">
                            <div>
                              <p><strong>Serial:</strong> {item.serialNumber}</p>
                              <p><strong>Variant:</strong> {item.variant}</p>
                              <p><strong>IMEI 1:</strong> {item.imei_1}</p>
                              <p><strong>IMEI 2:</strong> {item.imei_2}</p>
                              <p><strong>MRP:</strong> {item.mrp ? `₹${item.mrp}` : "N/A"}</p>
                              <p><strong>Distributor Price:</strong> {item.distributorPrice ? `₹${item.distributorPrice}` : "N/A"}</p>
                              <p><strong>Retailer Price:</strong> {item.retailerPrice ? `₹${item.retailerPrice}` : "N/A"}</p>
                            </div>
                            <div>
                              <img
                                src={imageUrl}
                                alt={item.model}
                                className="w-20 h-20 object-contain rounded-md mt-3 mix-blend-multiply"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))
            )}
          </>
        )}

        {/* Sold Inventory*/}
 {value === 1 && (
          <div className="text-center py-10">
        
        <SoldInventory/>
          </div>)}
      </div>
    );
  };

  export default DistributorInventory;



  const SoldInventory = () => {
    const distributor = useDistributor();
    const [soldItems, setSoldItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState(""); // 🔹 New State for Search Query
  
    const getColor = (condition) => {
      switch (condition.toLowerCase()) {
        case "gold":
          return "yellow-500";
        case "platinum":
          return "gray-300";
        case "silver":
          return "gray-400";
        default:
          return "white";
      }
    };
  
    useEffect(() => {
      const fetchSoldItems = async () => {
        if (!distributor?.soldItems || distributor.soldItems.length === 0) {
          console.warn("No sold items found.");
          setSoldItems([]);
          setLoading(false);
          return;
        }
    
        try {
          const productFetches = distributor.soldItems.map(async (serial) => {
            const productRef = doc(db, "all-products", serial);
            const productSnap = await getDoc(productRef);
            return productSnap.exists() ? { id: serial, ...productSnap.data() } : null;
          });
    
          const products = (await Promise.all(productFetches)).filter(Boolean);
          setSoldItems(products);
        } catch (error) {
          console.error("Error fetching sold items:", error);
        } finally {
          setLoading(false);
        }
      };
    
      fetchSoldItems();
    }, [distributor]);
    
  
    if (loading) return <div>Loading Sold Inventory...</div>;
  
    // 🔹 Filter Sold Items Based on Search Query
    const filteredSoldItems = soldItems.filter((item) =>
      item.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.variant.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.imei_1.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.imei_2.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (item.serialNumber && item.serialNumber.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  
    if (filteredSoldItems.length === 0)
      return (
    <>
       {/* 🔹 Search Input for Sold Inventory */}
       <div className="flex my-1">
       <input
         type="text"
         placeholder="Search Sold Inventory..."
         value={searchQuery}
         onChange={(e) => setSearchQuery(e.target.value)}
         className="w-80 h-10 px-4 text-black rounded border border-gray-300"
       />
     </div>
        <div className="text-center py-10">
          <h2 className="text-2xl font-bold text-gray-500">No sold items found</h2>
        </div>
        </>
      );
  
    // Grouping sold items by brand
    const groupedSoldItems = filteredSoldItems.reduce((acc, item) => {
      (acc[item.brand] = acc[item.brand] || []).push(item);
      return acc;
    }, {});
  
    return (
      <div>
        {/* 🔹 Search Input for Sold Inventory */}
        <div className="flex my-1">
          <input
            type="text"
            placeholder="Search Sold Inventory..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-80 h-10 px-4 text-black rounded border border-gray-300"
          />
        </div>
  
        {Object.keys(groupedSoldItems).map((brand) => (
          <div key={brand} className="my-8">
            <h2 className="bg-red-600 text-center text-xl rounded-lg">{brand}</h2>
            <div className="flex gap-4 overflow-x-auto p-3">
              {groupedSoldItems[brand].map((item) => {
                const brandData = data.brands.find((b) =>
                  b.models.some((model) => model.name === item.model)
                );
                const modelData = brandData?.models.find((m) => m.name === item.model);
                const imageUrl = modelData?.imageUrl || "https://via.placeholder.com/100";
  
                return (
                  <div
                    key={item.id}
                    className="bg-white border border-gray-200 rounded-lg w-[300px] shrink-0 p-5 shadow-xl flex flex-col items-center"
                  >
                    <div className="flex w-full justify-between mb-1">
                      <h3 className="text-sm font-bold text-gray-800">{item.model}</h3>
                      <span className={`text-xs font-semibold px-2 py-0.5 rounded-full bg-${getColor(item.condition)} text-white`}>
                        {item.condition}
                      </span>
                    </div>
                    <div className="flex-1 text-gray-700 text-xs space-y-1 w-full flex">
                      <div className="flex flex-col items-start text-left">
                        <p><strong>Serial:</strong> {item.serialNumber}</p>
                        <p><strong>Variant:</strong> {item.variant}</p>
                        <p><strong>IMEI 1:</strong> {item.imei_1}</p>
                        <p><strong>IMEI 2:</strong> {item.imei_2}</p>
                        <p><strong>MRP:</strong> {item.mrp ? `₹${item.mrp}` : "N/A"}</p>
                      </div>
                      <div>
                        <img
                          src={imageUrl}
                          alt={item.model}
                          className="w-20 h-20 object-contain rounded-md mt-3 mix-blend-multiply"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  
  
